import type { Order } from '../../gql/__generated__/order-core';

import {
    randBoolean,
    randNumber,
    randRecentDate,
    randUuid,
} from '@ngneat/falso';

import {
    mockOrderCollection,
    mockOrderCompany,
    mockOrderComposition,
    mockOrderIssuer,
    mockOrderState,
    mockOrderStyle,
} from './mockOrderFragments';

/** Will return a mocked Order object, useful for tests etc. */
const mockOrder = (overwrite?: Partial<Order>): Order => {
    const baseOrder: Order = {
        businessTradingPartner: mockOrderCompany(),
        collection: mockOrderCollection(),
        composition: mockOrderComposition(),
        createdDate: randRecentDate(),
        earliestCargoClosingDate: randRecentDate(),
        factory: mockOrderCompany(),
        isKeyCustomer: randBoolean(),
        isPackingNoteTransmitted: randBoolean(),
        isPreliminaryOrder: randBoolean(),
        isReadyForLabelProduction: randBoolean(),
        issuer: mockOrderIssuer(),
        keyOrder: null,
        orderCode: randUuid()
            .replaceAll('-', '')
            .substring(0, 13)
            .toUpperCase(),
        orderNumber: randNumber({ min: 10000000, max: 20000000 }),
        orderState: mockOrderState(),
        quantity: randNumber({ min: 100, max: 5000 }),
        style: mockOrderStyle(),
        supplier: mockOrderCompany(),
    };

    return { ...baseOrder, ...overwrite };
};

export { mockOrder };
